import { z } from "zod";

// سال مدل خودرو میلادی است (کاتالوگ، خودروی مشتری، سفارش). سال خرید و سال‌های شماره‌گذاری شمسی می‌مانند.
// این فایل بدون وابستگی سروری است تا فرم‌های web و admin هم همین بازه را بخوانند.

export const MODEL_YEAR_MIN = 1990;

/** تا یک سال جلوتر: مدل سال بعد معمولاً از پاییز عرضه می‌شود */
export const modelYearMax = () => new Date().getFullYear() + 1;

export const modelYearSchema = z
  .number()
  .int()
  .refine((year) => year >= MODEL_YEAR_MIN && year <= modelYearMax(), {
    message: `model year must be Gregorian, ${MODEL_YEAR_MIN}..next year`,
  });

/** مهاجرت داده: سال مدل شمسی قدیمی به میلادی (۱۴۰۵ → ۲۰۲۶) */
export const jalaliToGregorianModelYear = (year: number) => (year < 1700 ? year + 621 : year);
